import { Divider } from 'antd';
import styled from '@emotion/styled';

export const CustomDivider = styled(Divider)`
  background-color: #707070 !important;
`;
